<template lang="pug">
form(@submit.prevent="onSubmit")
  modal(active title="Nova Assinatura" @close="$emit('close')")
    .columns(slot="modal-body" style="min-height: auto")
      .columns
        .column.col-6
          form-group(label="Data de ínicio" :validation="$v.subscription" field="startAt")
            datepicker(v-model="$v.subscription.startAt.$model")
        .column.col-6
          form-group(label="Data de expiração" :validation="$v.subscription" field="expiresIn")
            datepicker(v-model="$v.subscription.expiresIn.$model")
        .column.col-6.col-sm-12
          form-group(label="Status" :validation="$v.subscription" field="status")
             select.form-select(v-model="$v.subscription.status.$model")
                option(v-for="status, key in subscriptionStatus" :value="key") {{status}}
        .column.col-6.col-sm-12(style="min-height: 300px")
          form-group(label="Plano" :validation="$v.subscription" field="planId")
            plan-autocomplete(v-model="$v.subscription.planId.$model")
        .column.col-12.divider
    .text-right(slot="modal-footer")
      .column.col-12.text-right
        button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { SUBSCRIPTION_STATUS } from '@/config/constants'
import plansServices from '@/services/plans'
import subscriptionsServices from '@/services/subscriptions'

export default {
  data() {
    return {
      loading: false,
      subscription: {
        startAt: new Date(),
        expiresIn: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
        status: 'active',
        planId: null,
        canceledAt: null,
        overdue: false,
        personId: null,
        paymentMethod: 'credit_card',
      },
      subscriptionStatus: SUBSCRIPTION_STATUS,
      plansList: [],
      plan: null,
    }
  },

  props: {
    personId: { required: true, type: [String, Number] },
  },

  computed: {
    disabled() {
      return this.loading || this.$v.$invalid
    },
  },

  async created() {
    this.subscription.personId = this.personId
    await this.fetchPlansList()
  },

  methods: {
    async fetchPlansList() {
      try {
        const { data } = await plansServices.list({
          limit: 100,
          q: { isManualPayment: true, status: true },
        })
        this.plansList = data.rows
      } catch (e) {
        this.$toaster.error('Erro ao carregar lista de planos')
      }
    },

    async onSubmit() {
      try {
        this.loading = true
        await subscriptionsServices.create(this.subscription)
        this.$emit('subscription-created')
        this.$emit('close')
      } catch (e) {
        this.$toaster.error('Erro ao criar assinatura')
      } finally {
        this.loading = false
      }
    },
  },

  validations: {
    subscription: {
      startAt: { required },
      expiresIn: { required },
      status: { required },
      planId: { required },
    },
  },
}
</script>
